import { createFileRoute } from '@tanstack/react-router';

import VoiceAgentPage from '../../views/dashboard-voice-sales/AgentPage';

export const Route = createFileRoute('/dashboard/voice-sales/agent')({
  component: VoiceAgentPage,
});
